module.exports = __webpack_public_path__ + "img/40_38_020_350.363dec0c.jpg";